import React from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

// CONTENT

const Content = ({ item = { data: { title: '' } } }) => (
  <Typo variant="b01" weight="medium" element="span">
    {item.data.title}
  </Typo>
);

Content.propTypes = {
  item: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
};

export default { Content };
